import {
    Box,
    Collapse,
    Divider,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Stack
} from "@mui/material";
import React, {
    useMemo,
    useState
} from "react";

import DataGroup from "../../lib/util/data/group/DataGroup";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import WorkTypeDTO from "../../lib/worktype/DTO/WorkTypeDTO";
import WorkTypePickerItem from "./WorkTypePickerItem";

interface WorkTypePickerCategoryListItemProps {
    readonly workTypeCategory: DataGroup<string, WorkTypeDTO>;
}

const WorkTypePickerCategoryListItem = (props: WorkTypePickerCategoryListItemProps) => {
    const { workTypeCategory } = props;
    /* Internal page states */
    const workTypeCategoryName: string = useMemo(() => {
        return workTypeCategory.key;
    }, [workTypeCategory]);
    const [isExpanded, setIsExpanded] = useState<boolean>();

    return (
        <>
            <ListItem
                sx={{ minHeight: "5em" }}
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <ListItemText primary={workTypeCategoryName} />
                <ListItemSecondaryAction>
                    <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                    >
                        <Box
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </Box>
                    </Stack>
                </ListItemSecondaryAction>
            </ListItem>
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                {
                    workTypeCategory.dataItems.map((workType) => {
                        return (
                            <React.Fragment key={workType.id}>
                                <Divider />
                                <WorkTypePickerItem
                                    key={workType.id}
                                    workTypeGroupId={workType.groupId}
                                />
                            </React.Fragment>
                        )
                    })
                }
            </Collapse>
        </>
    )
}

export default WorkTypePickerCategoryListItem;
